// extracted by mini-css-extract-plugin
export default {"button":"MainButtonTransparentBackground_button__WgQ3h"};